import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TarificacionRecomendadorComponent } from '../../components/tarificacion-recomendador/tarificacion-recomendador.component';

@Component({
	selector: 'app-tarificar-salud',
	standalone: true,
	imports: [
		CommonModule,
		TarificacionRecomendadorComponent
	],
	templateUrl: './tarificar-salud.view.html',
	styleUrls: ['./tarificar-salud.view.scss']
})
export class TarificarSaludView {}
